"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    ReturnPayloadWithoutTotalRecords: 'Return payload does not have totalRecords as expected',
    ReturnPayloadWithoutRecordsReturned: 'Return payload does not have totalRecords as expected'
};
